// JavaScript Document
var $ = jQuery.noConflict();
/* equalhight */
function equalhight() {
    $(".team-item").each(function(index, el) {
        if ($(el).find('.team-img').length > 0) {
            var $height = 0;
            $(el).find('.team-img').each(function(index2, el2) {
                $(el2).css("height", "auto");
                if (($(el2).innerHeight()) > $height) {
                    $height = $(el2).outerHeight();
                }
            });
            $(el).find('.team-img').css("height", $height);
        }
    });
}
$(window).on("load", function (e) {
    equalhight();   
    var href_val = window.location.hash;    
    $(".meet-people-list .team-img").each(function(){        
        var data_name_val = "#"+$(this).find(".team-name").attr("data-name");
        if(href_val == data_name_val){
            if (!$(this).closest("li").hasClass("people-sec-active")) {
                $(".meet-people-list > li").removeClass("people-sec-active");
                $(".team-content").hide();
                $(".team-content-wrap").css("height", "auto"); 
                $(this).closest("li").addClass("people-sec-active");
                var teamh = $(".people-sec-active .team-content").outerHeight();
                            $(".people-sec-active .team-content").parent().height(teamh); 
                $(this).closest("li.people-sec-active").find(".team-content").stop().slideDown(500, function() {
                    $(".people-sec-active .team-content").parent().height(teamh); 
                    if ($(window).scrollTop() != $(".people-sec-active").offset().top) {
                        if ($("#menu-toggle").is(':hidden')) {
                            $("html, body").stop().animate({
                                scrollTop: $(".people-sec-active").offset().top
                            }, 300);
                        } else {
                            $("html, body").stop().animate({
                                scrollTop: $(".people-sec-active").offset().top
                            }, 300);
                        }
                    }
                });                
            } 
        }
    });
});
$(document).ready(function () {
    $( ".form-open-btn" ).click(function(e) {
        $( ".get-touch-form" ).slideDown( "slow");
        e.preventDefault();
        $(this).addClass('active');        
    });
    
    $(".onlineenquiry").on("click",function(e){
        e.preventDefault();
        $( ".form-open-btn" ).trigger("click");
        $("html,body").animate({
            scrollTop:$(".get-touch-sec").offset().top
        });
    });
    
    $(".back-top").click(function(e) {
        e.preventDefault();
        $("html, body").stop().animate({
            scrollTop: 0
        }, 1000);
    });
    
    $('.enumenu_ul').responsiveMenu({
        'menuIcon_text': ''
        , onMenuopen: function () {}
    });

    $(".selectbox1").selectbox({
        hide_duplicate_option:true        
    });
    $(".selectbox2").selectbox({
        hide_duplicate_option:true        
    });
    $(".selectbox3").selectbox({
        hide_duplicate_option:true        
    });
    $(".selectbox4").selectbox({
        hide_duplicate_option:true        
    });
    $(".selectbox5").selectbox({
        hide_duplicate_option:true        
    });
    $(".sidebar-select").selectbox({
        hide_duplicate_option:true        
    });

    // team js
    $(".meet-people-list .team-img").click(function(e) {
    e.preventDefault();
    if (!$(this).closest("li").hasClass("people-sec-active")) {
        $(".meet-people-list > li").removeClass("people-sec-active");
        $(".team-content").hide();
        $(".team-content-wrap").css("height", "auto"); 
        $(this).closest("li").addClass("people-sec-active");
        var teamh = $(".people-sec-active .team-content").outerHeight();
                    $(".people-sec-active .team-content").parent().height(teamh); 
        $(this).closest("li.people-sec-active").find(".team-content").stop().slideDown(500, function() {
            $(".people-sec-active .team-content").parent().height(teamh); 
            if ($(window).scrollTop() != $(".people-sec-active").offset().top) {
                if ($("#menu-toggle").is(':hidden')) {
                    $("html, body").stop().animate({
                        scrollTop: $(".people-sec-active").offset().top
                    }, 300);
                } else {
                    $("html, body").stop().animate({
                        scrollTop: $(".people-sec-active").offset().top
                    }, 300);
                }
            }
        });                
    } else {
        event.preventDefault();        
        $(this).closest("li").removeClass("people-sec-active");
        $(this).closest("li").removeClass("people-sec-active").find(".team-content").stop().slideUp(600);
        var this_ = $(this);
        this_.closest("li").find(".team-content-wrap").stop().animate({
            "height": 0
        }, 600, function() {
            $(this).css("height", "");
        });
    }
});
    
    $(".enumenu_ul.top-menu > li").click(function(){;  
        if($(".menu-icon").css("display") == "block"){
            if($(this).hasClass("has-children")){
                $(this).children(".sub-menu").slideToggle();
            }
            else{
                window.location = this.href;
            }
        }
    });
    
    $(".menu-icon").on("click",function(){
        if($(window).innerWidth() <= 991){
            if(!$(this).hasClass("mob-menu-active")){
                $(".menu-icon").removeClass("mob-menu-active");
                $(this).addClass("mob-menu-active");
                $(this).nextAll(".enumenu_ul.menu").slideDown();
            }
            else{
                $(this).removeClass("mob-menu-active").nextAll(".enumenu_ul.menu, .mob-menu").slideUp();
            }    
        }
    });
    if($(".menu-icon").css("display") == "block"){
        $(".header-top-menu .enumenu_ul").insertAfter(".menu-sec .enumenu_ul.menu.mob");
        $(".enumenu_ul.menu.desk").addClass("mob-menu");
    }   
    
    $(window).resize(function(event) {  
        equalhight(); 
        var teamh = $(".people-sec-active .team-content").outerHeight();
                    $(".people-sec-active .team-content").parent().height(teamh);
        if($(".menu-icon").css("display") == "block"){
            $(".header-top-menu .enumenu_ul").insertAfter(".menu-sec .enumenu_ul.menu.mob");
            $(".enumenu_ul.menu.desk").addClass("mob-menu");
        }   
        else{
            if($(".enumenu_ul.top-menu").css("display") == "block"){
                $(".enumenu_ul.top-menu > li .sub-menu").hide(); 
                $(".enumenu_ul.top-menu").hide();
                $(".menu-icon").removeClass("mob-menu-active");
                $(".sub-menu.sb-menu").removeAttr("style");
            }
    
            if($(".mob-menu").length > 0){
                $(".mob-menu").insertAfter(".header-top-menu .menu-icon");
            }
        }
    });
    
    /*
    * Ovulation Calculator
    */
    $('#ovulcal').on('click',function(){
       $.ajax({
           url: ajax_variable,
           type: 'POST',
           dataType: "json",
           data: {
               'action': 'calculate_ovulation',
               'datemonth': $('.datemonth').val(),
               'dateday':$('.dateday').val(),
               'dateyear':$('.dateyear').val(),
               'days':$('.days').val(),
               'postid' : post_id
           },
           beforeSend: function() {
               $('.loader').show();
           },
           complete: function() {
               $('.loader').hide();
           },
           success: function(r) {
               if (r.response == "success") {
                   $('.ovul_cal_ques').hide();
                   $('.fertility-result').show();
                   $('.fertility-result').html(r.message);
               } else {
                   $('.ovul_cal_ques').hide();
                   $('.fertility-result').show();
                   $('.fertility-result').html('<div class="error-section">'+r.message+'</div>');
               }
           }
       });  
    });
    
    /*
     * Calculate again click event
     */
    $('body').on('click','.calculate_again',function(){
        $('.ovul_cal_ques').show();
        $('.fertility-result').html('');
    });
    
    /*
    * Filter post by category,author
    */
    $('.category_filter + .sbHolder ul li a, .author_filter + .sbHolder ul li a').on('click',function(){
        
       $('#author_id').val($('.author_filter').val());
       var author_id = $('#author_id').val();
       
       $('#cat_id').val($('.category_filter').val());
       var cat_id = $('#cat_id').val();
       var posts_per_page = $('#posts_per_page').val();

       $('#offset').val(0);
       var offset = $('#offset').val();

       $('#search_type').val('default');
       $('#search-text').val('');
       
       if((offset == null) || (offset==0))
           offset = 0;

       $.ajax({
           url: ajax_variable,
           type: 'POST',
           dataType: "json",
           data: {
               'action': 'get_load_more_post',
               'cat_id':cat_id,
               'author_id':author_id,
               'posts_per_page':posts_per_page,
               'offset' : offset,
           },
           beforeSend: function() {
               $('.loader').show();
           },
           complete: function() {
               $('.loader').hide();
           },
           success: function(r) {
               if (r.response == "success") {
                    $('.blog-post-listing').html(r.message);
                    if(r.pagination_struc!=''){
                        $('.blog-pagination').show();
                        $('.blog-pagination').show();
                        $('.pagination_wrapper').html(r.pagination_struc);
                    }
                    if(r.pagination_struc==''){
                        $('.blog-pagination').hide();
                    }
                   
               } else {
                    $('.blog-post-listing').html('<div class="error-section">'+r.message+'</div>');
                    $('.blog-pagination').hide();
               }
           }
       }); 
    });
    
    /*
    * pagination ajax data
    */
    $(document).on("click", ".pagination_pageno",function() {
       if($.trim(this.className) != 'pagination_pageno')
       {
           return false;
       }
       
       $('.pagination_pageno').removeClass("active");
       $('.pagination_pageno[data-id='+$(this).attr('data-id')+']').addClass('active');
       
       var author_id = $('#author_id').val();
       var cat_id = $('#cat_id').val();
       var posts_per_page = $('#posts_per_page').val();
       var page_id = $(this).attr('data-id');
       var search_type = $('#search_type').val();
       
       var search_text = $('#search-text').val();
       
       $('#offset').val(0);
       var offset = $('#offset').val();
       
       if((offset == null) || (offset==0))
           offset = 0;

       $.ajax({
           url: ajax_variable,
           type: 'POST',
           dataType: "json",
           data: {
               'action': 'get_load_more_post_pagination',
               'cat_id':cat_id,
               'author_id':author_id,
               'posts_per_page':posts_per_page,
               'offset' : offset,
               'page_id' : page_id,
               'search_text': search_text,
               'search_type' : search_type
           },
           beforeSend: function() {
               $('.loader').show();
           },
           complete: function() {
               $('.loader').hide();
           },
           success: function(r) {
               if (r.response == "success") {
                    $('.blog-post-listing').html(r.message);
                    
                    $("html,body").animate({
                        scrollTop:$(".fertile-select-row").offset().top
                    },1000);
                    if(r.pagination_struc!='')
                    {
                        $('.blog-pagination').show();
                        $('.blog-pagination').show();
                        $('.pagination_wrapper').html(r.pagination_struc);
                    }
                    if(r.pagination_struc==''){
                        $('.blog-pagination').hide();
                    }
                   
               } else {
                    $('.blog-post-listing').html('<div class="error-section">'+r.message+'</div>');
                    $('.blog-pagination').hide();
               }
           }
       });
    });
    
    /*
     * Text box search
     */
    $("#search-text").keyup(function () {
        $(".fertile-select-row .sbHolder").each(function(){
            $(this).find(".sbOptions li").removeAttr("style");
            var res_text = $(this).find(".sbOptions li:first-child a").text();
            $(this).find(".sbSelector a").text(res_text); 
        });        
        /*
         * Empty author value
         */
        $('.author_filter').val('');
        $('#author_id').val('');
        
        /*
         * Empty category value
         */
        $('.category_filter').val('')
        $('#cat_id').val('');
        var text = $(".selectbox-row .sbOptions li a").text();
        $(".selectbox-row .sbSelector a").val(text);
       
        var search_text = $(this).val();
        var posts_per_page = $('#posts_per_page').val();
        
        $('#search_type').val('text');
        $('#offset').val(0);
        var offset = $('#offset').val();

        if((offset == null) || (offset==0))
            offset = 0;

        $.ajax({
            url: ajax_variable,
            type: 'POST',
            dataType: "json",
            data: {
                'action': 'get_post_custom_textbox_search',
                'search_text':search_text,
                'posts_per_page':posts_per_page,
                'offset' : offset,
            },
            beforeSend: function() {
                $('.loader').show();
            },
            complete: function() {
                $('.loader').hide();
            },
            success: function(r) {
                if (r.response == "success") {
                     $('.blog-post-listing').html(r.message);

                     $("html,body").animate({
                         scrollTop:$(".fertile-select-row").offset().top
                     },1000);
                     if(r.pagination_struc!='')
                     {
                         $('.blog-pagination').show();
                         $('.blog-pagination').show();
                         $('.pagination_wrapper').html(r.pagination_struc);
                     }
                     if(r.pagination_struc==''){
                        $('.blog-pagination').hide();
                    }

                } else {
                     $('.blog-post-listing').html('<div class="error-section">'+r.message+'</div>');
                     $('.blog-pagination').hide();
                }
            }
        });
    });
}); // end of ready funciton